import { Box, Typography, FormHelperText } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import GlassModal from '../../../../v2/MUI_custom_component/Modal/GlassModal';
import { CustomButton } from '../../../../v2/MUI_custom_component';
import digilockerAppScreenshot from '../../../../assets/digilocker-app-screenshot.png';
import aadhaarLogo from '../../../../assets/aadhaar-logo.png';
import digilockerLinkChain from '../../../../assets/digilocker-link-chain.svg';

const StepBadge = ({ number }) => (
  <Box
    sx={{
      width: 32,
      height: 32,
      borderRadius: '50%',
      bgcolor: '#995A00',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    }}
  >
    <Typography
      sx={{
        color: '#fff',
        fontSize: 16,
        fontWeight: 700,
        lineHeight: '24px',
      }}
    >
      {number}
    </Typography>
  </Box>
);

const VerifyPhoneModal = ({ open, onCancel, onVerified }) => {
  const handleLinkNow = () => {
    window.open('https://www.digilocker.gov.in/', '_blank');
  };

  return (
    <GlassModal
      open={open}
      onClose={onCancel}
      title="What You'll Need"
      topMobile='22%'
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
        }}
      >
        {/* Steps section */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant='h2'>
            To continue, complete the steps below:
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {/* Step 1 */}
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
              <StepBadge number='1' />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                  flex: 1,
                }}
              >
                <Typography variant='h2'>Create digilocker account.</Typography>
                <Box
                  component='img'
                  src={digilockerAppScreenshot}
                  alt='DigiLocker app'
                  sx={{
                    width: 61,
                    height: 68,
                    borderRadius: 1,
                    objectFit: 'cover',
                  }}
                />
              </Box>
            </Box>

            {/* Step 2 */}
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
              <StepBadge number='2' />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                  flex: 1,
                }}
              >
                <Typography variant='h2'>
                  Add proprietor or partner's Aadhaar to digilocker account.
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                  <Box
                    component='img'
                    src={aadhaarLogo}
                    alt='Aadhaar'
                    sx={{ width: 75, height: 50, objectFit: 'contain' }}
                  />
                  <Box
                    component='img'
                    src={digilockerLinkChain}
                    alt='link'
                    sx={{ width: 43, height: 27, objectFit: 'contain' }}
                  />
                  <Box
                    component='img'
                    src={digilockerAppScreenshot}
                    alt='DigiLocker app'
                    sx={{
                      width: 61,
                      height: 68,
                      borderRadius: 1,
                      objectFit: 'cover',
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Box>

          {/* Warning */}
          <Box
            sx={{
              display: 'flex',
              gap: 0.5,
              alignItems: 'flex-start',
              pt: 0.25,
            }}
          >
            <WarningAmberIcon
              sx={{
                color: '#CC0000',
                flexShrink: 0,
                fontSize: 16,
              }}
            />
            <Typography variant='body1' color='#CC0000'>
              {`*If the above steps are complete, proceed to "Continue"`}
            </Typography>
          </Box>
        </Box>

        {/* Buttons */}
        <Box sx={{ display: 'flex', gap: 1 }}>
          <CustomButton
            variant='outlined'
            color='primary'
            label='Link now'
            onClick={handleLinkNow}
            sx={{ flex: 1 }}
          />
          <CustomButton
            variant='filled'
            color='primary'
            label='Continue'
            onClick={onVerified}
            sx={{ flex: 1 }}
          />
        </Box>
      </Box>
    </GlassModal>
  );
};

export default VerifyPhoneModal;
